import { z } from 'zod';
export const DATA_TABLE_KPI_COLUMN_NAMES_TO_REQUIREMENTS = {
    sales_amount: {
        granularity: 'sales',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_amount_without_promo: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_amount_with_promo: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_amount_promo_percent: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_quantity: {
        granularity: 'quantity',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_quantity_without_promo: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_quantity_with_promo: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_quantity_promo_percent: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    average_weekly_sales_amount: {
        granularity: 'averageWeeklySales',
        taxonomy: ['carrefour'],
        period: '!date_key_month'
    },
    average_weekly_sales_quantity: {
        granularity: 'averageWeeklySales',
        taxonomy: ['carrefour'],
        period: '!date_key_month'
    },
    average_price: {
        granularity: 'averagePrice',
        taxonomy: ['carrefour', 'nielsen']
    },
    average_price_with_promo: {
        granularity: 'promotion',
        taxonomy: ['carrefour', 'nielsen']
    },
    sales_possession_rate: {
        granularity: 'salesPossessionRate',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    gross_service_rate_downstream: {
        granularity: 'grossServiceRate',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    gross_service_rate_upstream: {
        granularity: 'grossServiceRate',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    net_service_rate_downstream: {
        granularity: 'netServiceRate',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    net_service_rate_upstream: {
        granularity: 'netServiceRate',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    supplier_market_share_sales_amount: {
        granularity: 'carrefourMarketShare',
        taxonomy: ['carrefour']
    },
    supplier_market_share_sales_quantity: {
        granularity: 'carrefourMarketShare',
        taxonomy: ['carrefour']
    },
    nielsen_market_share_sales_amount: {
        granularity: 'nielsenMarketShare',
        taxonomy: ['nielsen']
    },
    nielsen_market_share_sales_quantity: {
        granularity: 'nielsenMarketShare',
        taxonomy: ['nielsen']
    },
    supplier_market_share_sales_amount_comparison: {
        granularity: 'carrefourMarketShare',
        taxonomy: ['carrefour']
    },
    supplier_market_share_sales_quantity_comparison: {
        granularity: 'carrefourMarketShare',
        taxonomy: ['carrefour']
    },
    nielsen_market_share_sales_amount_comparison: {
        granularity: 'nielsenMarketShare',
        taxonomy: ['nielsen']
    },
    nielsen_market_share_sales_quantity_comparison: {
        granularity: 'nielsenMarketShare',
        taxonomy: ['nielsen']
    },
    warehouse_stock_value: {
        granularity: 'warehouseStock',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    warehouse_stock_quantity: {
        granularity: 'warehouseStock',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    store_stock_value: {
        granularity: 'storeStock',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    store_stock_quantity: {
        granularity: 'storeStock',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    total_stock_value: {
        granularity: ['storeStock', 'warehouseStock'],
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    total_stock_quantity: {
        granularity: ['storeStock', 'warehouseStock'],
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    number_of_transactions: {
        granularity: 'businessEquationAllCustomers',
        taxonomy: ['carrefour']
    },
    average_basket_amount: {
        granularity: 'businessEquationAllCustomers',
        taxonomy: ['carrefour']
    },
    average_basket_amount_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    average_basket_quantity: {
        granularity: 'businessEquationAllCustomers',
        taxonomy: ['carrefour']
    },
    carrefour_market_sales: {
        granularity: 'businessEquationAllCustomers',
        taxonomy: ['carrefour']
    },
    number_of_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    sales_amount_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    sales_amount_non_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    number_of_transactions_non_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    average_basket_amount_non_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    average_basket_quantity_non_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    average_price_non_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    frequency_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    sales_by_customer_cardholders: {
        granularity: 'businessEquationCardholdersNonCardholders',
        taxonomy: ['carrefour']
    },
    number_of_references_held_theoretical: {
        granularity: 'possessionZoomPageWithTheoretical',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    number_of_references_not_held: {
        granularity: 'possessionZoomPage',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    number_of_holder_stores_theoretical: {
        granularity: 'possessionZoomPageWithTheoretical',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    number_of_non_holder_stores: {
        granularity: 'possessionZoomPage',
        taxonomy: ['carrefour'],
        notif: ['FRA']
    },
    numerical_distribution: {
        granularity: 'numericalDistribution',
        taxonomy: ['carrefour']
    },
    weighted_distribution: {
        granularity: 'weightedDistribution',
        taxonomy: ['carrefour']
    },
    bcp_chain_desc: {
        granularity: 'banner',
        taxonomy: ['carrefour']
    },
    non_possession_in_stock_no_sales: {
        granularity: 'nonPossessed',
        taxonomy: ['carrefour']
    },
    non_possession_out_of_stock_no_sales: {
        granularity: 'nonPossessed',
        taxonomy: ['carrefour']
    },
    non_possession_depicked: {
        granularity: 'nonPossessed',
        taxonomy: ['carrefour'],
        country: ['FRA']
    },
    competitor_sales_amount: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_amount_without_promo: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_amount_with_promo: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_amount_promo_percent: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_quantity: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_quantity_without_promo: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_quantity_with_promo: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_sales_quantity_promo_percent: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_average_weekly_sales_amount: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_average_weekly_sales_quantity: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_supplier_market_share_sales_amount: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_supplier_market_share_sales_quantity: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_supplier_market_share_sales_amount_comparison: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    competitor_supplier_market_share_sales_quantity_comparison: {
        granularity: 'competitorVision',
        taxonomy: ['carrefour']
    },
    // Dynamic Client datatable
    customer_movement_type: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    customer_movement_type_detailed_key: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_amount_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_amount_by_movement_with_promo: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_amount_by_movement_without_promo: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement_with_promo: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement_without_promo: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_nb_transactions_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    nb_cardholder_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_by_customer_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_by_customer_by_movement_comparison: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_frequency_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_frequency_by_movement_comparison: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_average_basket_in_value_by_movement: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_average_basket_in_value_by_movement_comparison: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    // Dynamic client benchmark
    cardholder_sales_amount_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_amount_by_movement_with_promo_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_amount_by_movement_without_promo_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement_with_promo_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_sales_quantity_by_movement_without_promo_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_nb_transactions_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    nb_cardholder_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    date_key_evolution_date: {
        granularity: 'dateGranularity',
        taxonomy: ['carrefour']
    },
    date_key_evolution_month: {
        granularity: 'dateGranularity',
        taxonomy: ['carrefour']
    },
    date_key_evolution_week: {
        granularity: 'dateGranularity',
        taxonomy: ['carrefour']
    },
    cardholder_sales_by_customer_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_frequency_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    cardholder_average_basket_in_value_by_movement_benchmark: {
        granularity: 'dynamicClientZoomPage',
        taxonomy: ['carrefour']
    },
    business_brand: {
        granularity: 'businessBrand',
        taxonomy: ['carrefour']
    },
    business_brand_reduced: {
        granularity: 'businessBrand',
        taxonomy: ['carrefour']
    },
    // Customer Segmentation
    customer_segmentation_cardholder_sales_amount: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_amount_share: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_quantity: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_quantity_share: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_per_customer: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_quantity_with_promo: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_quantity_without_promo: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_amount_with_promo: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_sales_amount_without_promo: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_nb_cardholders: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_nb_cardholders_share: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_nb_transactions: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_frequency: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_average_basket_in_value: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_average_basket_in_unit: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    },
    customer_segmentation_cardholder_average_price: {
        granularity: 'customerSegmentation',
        taxonomy: ['carrefour']
    }
};
export const DATA_TABLE_VIEWS = [
    'performance',
    'businessEquationAllCustomersDetail',
    'businessEquationCardholdersNonCardholdersDetail',
    'salesAmountDetail',
    'salesQuantityDetail',
    'possessionZoomPage',
    'possessionZoomPageWithTheoretical',
    'projectDetail',
    'dnDvDetail',
    'competitorVision',
    'dynamicClient',
    'customerSegmentationConsostyle',
    'customerSegmentationLifestage'
];
const CUSTOMER_SEGMENTATION_KPIS = [
    'customer_segmentation_cardholder_sales_amount',
    'customer_segmentation_cardholder_sales_amount_share',
    'customer_segmentation_cardholder_sales_amount_with_promo',
    'customer_segmentation_cardholder_sales_amount_without_promo',
    'customer_segmentation_cardholder_sales_quantity',
    'customer_segmentation_cardholder_sales_quantity_share',
    'customer_segmentation_cardholder_sales_quantity_with_promo',
    'customer_segmentation_cardholder_sales_quantity_without_promo',
    'customer_segmentation_nb_cardholders',
    'customer_segmentation_nb_cardholders_share',
    'customer_segmentation_cardholder_nb_transactions',
    'customer_segmentation_cardholder_sales_per_customer',
    'customer_segmentation_cardholder_frequency',
    'customer_segmentation_cardholder_average_basket_in_value',
    'customer_segmentation_cardholder_average_basket_in_unit',
    'customer_segmentation_cardholder_average_price'
];
/**
 * Maps a derived "share" column to the base KPI it is a percentage of. Single source of truth used to
 * compute the share backend (value / total * 100) and to sort the column server-side on its base measure
 * (same order, since the denominator is constant across the query).
 */
export const DATA_TABLE_SHARE_KPIS = {
    customer_segmentation_cardholder_sales_amount_share: 'customer_segmentation_cardholder_sales_amount',
    customer_segmentation_cardholder_sales_quantity_share: 'customer_segmentation_cardholder_sales_quantity',
    customer_segmentation_nb_cardholders_share: 'customer_segmentation_nb_cardholders'
};
/** True when the column is a derived "share" column (rendered as a percentage). */
export function isDataTableShareKpi(kpi) {
    return kpi in DATA_TABLE_SHARE_KPIS;
}
export const DATA_TABLE_KPIS_PER_VIEW = {
    performance: [
        'sales_amount',
        'sales_amount_without_promo',
        'sales_amount_with_promo',
        'sales_amount_promo_percent',
        'sales_quantity',
        'sales_quantity_without_promo',
        'sales_quantity_with_promo',
        'sales_quantity_promo_percent',
        'average_weekly_sales_amount',
        'average_weekly_sales_quantity',
        'average_price',
        'average_price_with_promo',
        'supplier_market_share_sales_amount',
        'supplier_market_share_sales_amount_comparison',
        'supplier_market_share_sales_quantity',
        'supplier_market_share_sales_quantity_comparison',
        'nielsen_market_share_sales_amount',
        'nielsen_market_share_sales_amount_comparison',
        'nielsen_market_share_sales_quantity',
        'nielsen_market_share_sales_quantity_comparison',
        'sales_possession_rate',
        'gross_service_rate_upstream',
        'gross_service_rate_downstream',
        'net_service_rate_upstream',
        'net_service_rate_downstream',
        'warehouse_stock_value',
        'warehouse_stock_quantity',
        'store_stock_value',
        'store_stock_quantity',
        'total_stock_value',
        'total_stock_quantity',
        'number_of_transactions',
        'average_basket_amount',
        'average_basket_amount_cardholders',
        'number_of_cardholders'
    ],
    businessEquationAllCustomersDetail: [
        'supplier_market_share_sales_amount',
        'supplier_market_share_sales_amount_comparison',
        'carrefour_market_sales',
        'sales_quantity',
        'sales_amount',
        'number_of_transactions',
        'average_basket_amount',
        'average_basket_quantity',
        'average_price'
    ],
    businessEquationCardholdersNonCardholdersDetail: [
        'supplier_market_share_sales_amount',
        'supplier_market_share_sales_amount_comparison',
        'carrefour_market_sales',
        'sales_quantity',
        'sales_amount',
        'sales_amount_non_cardholders',
        'number_of_transactions_non_cardholders',
        'average_basket_amount_non_cardholders',
        'average_basket_quantity_non_cardholders',
        'average_price_non_cardholders',
        'sales_amount_cardholders',
        'number_of_cardholders',
        'sales_by_customer_cardholders',
        'frequency_cardholders',
        'average_basket_amount_cardholders'
    ],
    salesAmountDetail: [
        'sales_amount',
        'sales_amount_without_promo',
        'sales_amount_with_promo',
        'sales_amount_promo_percent'
    ],
    salesQuantityDetail: [
        'sales_quantity',
        'sales_quantity_without_promo',
        'sales_quantity_with_promo',
        'sales_quantity_promo_percent'
    ],
    possessionZoomPage: [
        'sales_possession_rate',
        'sales_amount',
        'sales_quantity',
        'average_weekly_sales_amount',
        'average_weekly_sales_quantity',
        'number_of_non_holder_stores',
        'number_of_references_not_held',
        'non_possession_depicked',
        'non_possession_in_stock_no_sales',
        'non_possession_out_of_stock_no_sales'
    ],
    possessionZoomPageWithTheoretical: [
        'sales_possession_rate',
        'sales_amount',
        'sales_quantity',
        'average_weekly_sales_amount',
        'average_weekly_sales_quantity',
        'number_of_holder_stores_theoretical',
        'number_of_non_holder_stores',
        'number_of_references_held_theoretical',
        'number_of_references_not_held',
        'non_possession_depicked',
        'non_possession_in_stock_no_sales',
        'non_possession_out_of_stock_no_sales'
    ],
    projectDetail: [
        'sales_amount',
        'sales_amount_with_promo',
        'sales_amount_without_promo',
        'sales_amount_promo_percent',
        'sales_quantity',
        'sales_quantity_without_promo',
        'sales_quantity_with_promo',
        'sales_quantity_promo_percent',
        'average_weekly_sales_amount',
        'average_weekly_sales_quantity',
        'average_price',
        'average_price_with_promo',
        'supplier_market_share_sales_amount',
        'supplier_market_share_sales_quantity',
        'nielsen_market_share_sales_amount',
        'nielsen_market_share_sales_quantity'
    ],
    dnDvDetail: [
        'sales_amount',
        'sales_quantity',
        'average_weekly_sales_amount',
        'average_weekly_sales_quantity',
        'numerical_distribution',
        'weighted_distribution'
    ],
    competitorVision: [
        'competitor_sales_amount',
        'competitor_sales_amount_without_promo',
        'competitor_sales_amount_with_promo',
        'competitor_sales_amount_promo_percent',
        'competitor_sales_quantity',
        'competitor_sales_quantity_without_promo',
        'competitor_sales_quantity_with_promo',
        'competitor_sales_quantity_promo_percent',
        'competitor_average_weekly_sales_amount',
        'competitor_average_weekly_sales_quantity',
        'competitor_supplier_market_share_sales_amount',
        'competitor_supplier_market_share_sales_quantity'
    ],
    dynamicClient: [
        'cardholder_sales_amount_by_movement',
        'cardholder_sales_amount_by_movement_with_promo',
        'cardholder_sales_amount_by_movement_without_promo',
        'cardholder_sales_quantity_by_movement',
        'cardholder_sales_quantity_by_movement_with_promo',
        'cardholder_sales_quantity_by_movement_without_promo',
        'cardholder_nb_transactions_by_movement',
        'nb_cardholder_by_movement',
        'cardholder_sales_by_customer_by_movement',
        'cardholder_frequency_by_movement',
        'cardholder_average_basket_in_value_by_movement'
    ],
    customerSegmentationConsostyle: CUSTOMER_SEGMENTATION_KPIS,
    customerSegmentationLifestage: CUSTOMER_SEGMENTATION_KPIS
};
export const DATA_TABLE_REQUIRED_KPI_PER_VIEW = {
    possessionZoomPage: ['sales_possession_rate'],
    possessionZoomPageWithTheoretical: ['sales_possession_rate']
};
export const DATA_TABLE_REQUIRED_DIMENSION_PER_VIEW = {
    dnDvDetail: ['barcode'],
    competitorVision: ['competitor_desc_anonymized'],
    dynamicClient: ['customer_movement_type'],
    customerSegmentationConsostyle: ['trad_consostyle_macro_desc'],
    customerSegmentationLifestage: ['trad_lifestage_macro_desc']
};
export const EXPORT_TYPES = ['excel', 'csv', 'excelWithTopFlop'];
export const ExportOptionsSchema = z.object({
    exportType: z.enum(EXPORT_TYPES),
    withTopFlopSalesAmount: z.boolean().default(false),
    withTopFlopSalesQuantity: z.boolean().default(false)
});
//# sourceMappingURL=datatable.model.js.map